// Helper function to retrieve a random expert if a collection exists and making sure random number is not out of collection length
export const getRandomExpert = (collection) => {
  return collection && collection.length > 0
    ? collection[Math.floor(Math.random() * collection.length)]
    : null;
};

export const randomExpertInPriority = (city, region, country) => {
  // Priority set by client is we should show at random experts from  expert collection but we should look for city experts first, then region, then country

  // City expert collections
  const cityExpertDetail = getRandomExpert(city);
  if (cityExpertDetail) return cityExpertDetail;

  // Region expert collections
  const regionExpertDetail = getRandomExpert(region);
  if (regionExpertDetail) return regionExpertDetail;

  // Country expert collections
  const countryExpertDetail = getRandomExpert(country);
  if (countryExpertDetail) return countryExpertDetail;
};
